import { Component,Input, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';
import { APIService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DataService} from 'src/app/services/data.service';



@Component({
  selector: 'app-sub-categories',
  templateUrl: './sub-categories.component.html',
  styleUrls: ['./sub-categories.component.scss']
})

export class SubCategoriesComponent implements OnInit {

  @Input() mdlRef: any;
  @Input() typeID: any;
  @Input() CName: any;
  changingValue: Subject<boolean> = new Subject();

  isEditSubCategory: boolean = false;
  subInd:number = 0;
  Id: number = 0;
  mainCid: number = 0;
  subCategory: string = '';
  categoryName: string = '';
  CID: number = 1;
  categories: any = [];
  jarvisData: any = [];
  subCat: any = [];
  agencyData: any = [];
  
  //  *new var
  tempData: any = {
    subCategoryID: 0,
    categoryID: 0,
    categoryName: '',
    type: '' 
  }
 
  constructor(private modalService: NgbModal,private router: Router,private apiService: APIService, private http: HttpClient,private dataSer: DataService) { }
  
  ngOnInit(): void {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    
    //this.getCategory();
    this.mainCid = this.typeID;
    this.categoryName = this.CName;
    this.dataSer.dataTransfer.subscribe((value: any) =>{
      if(value){
        this.categoryName = value.cnm;
        this.subCat = value.sub;
        this.subCat.sort((a:any,b:any) => a.snm.localeCompare(b.snm));
        let category = value.categories;
        if(category){
          this.categories = JSON.parse(category);
        }
      }
    });


  }

  closeResult: any;
  modalReference: any;

  //getCategory - get categoris
  getCategory(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }

  //successResp - success  get handler   
  successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
            var reponseData = JSON.parse(res.updatePackage);
            if (reponseData.Table2) {
                let editDataArry = JSON.parse(reponseData.Table2[0].ItemCategories);
                for(let j = 0; j < editDataArry.length; j++){
                  this.categories.push({
                    'cid': editDataArry[j].cid,
                    'cnm': editDataArry[j].cnm,
                    'sub': editDataArry[j].sub,
                });
              }

              let tmpID = this.mainCid;
              let tmpSubCat = editDataArry.filter(function (element: any, index: any) {
                return (element.cid == tmpID);
              });
debugger
              this.subCat = tmpSubCat;
              this.subCat.sort((a:any,b:any) => a.snm.localeCompare(b.snm));
              console.log(this.subCat)
            }
        }
    }
  }

  

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    // else {
    //     alert(res.message);
    // }
  }

  //open() - open edit and add sub-categories modal 
  open(content: any, id:number) {
    debugger
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      if(id == 0){
        this.isEditSubCategory = false;
        this.tempData.categoryName = '';     
      }
      else if(id != 0){
        var SubCatData = this.subCat.filter(function (element: any, index: any) {
          return (element.sid == id);
        });
        this.isEditSubCategory = true;
        this.Id = id;
        const catOld:string = SubCatData[0].snm;
        this.tempData.categoryName = catOld;
      }
   
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
      this.isEditSubCategory = false;
  }

  public closeModal($event: any) {
    this.isEditSubCategory = false;
      this.modalReference.close();
      if ($event) {
          this.changingValue.next($event);
      }
  }
  public closeSubModal() {
    this.mdlRef.close();
    this.isEditSubCategory = false;  
  }

  

  saveNewSubCat(){
    var cat = this.tempData.categoryName
    var SubCatData = this.subCat.filter(function (element: any, index: any) {
      return (element.cat ==  cat);
    });
    if(cat == ''){
      this.apiService.successAlert("Please enter sub-category name.")
      return;
    }
    let flag = false;
    let temp = {
      sid: this.subCat.length + 1,
      snm:cat,
    }
    for (let i = 0; i < this.subCat.length; i++) {
      if(cat.toUpperCase() == this.subCat[i].snm.toUpperCase()){
        flag = true
        break
      }
    }
    this.tempData = {
      subCategoryID: 0,
      categoryID: this.typeID,
      categoryName: cat,
      type: 'ITMCTGS' 
    }
    if(!flag){
      this.subCat.push(temp);      
      this.save();
      this.tempData.categoryName = '';
      this.modalReference.close();
    }
    else
    {
      this.apiService.successAlert("This sub-category already exists.")
      this.tempData.categoryName = '';
      return;
    }
  } 

  editSubCat(){
    var name = this.tempData.categoryName
    var id = this.Id
    var SubCatData = this.subCat.filter(function (element: any, index: any) {
      return (element.sid ==  id);
    });
    if(name == ''){
      this.tempData.categoryName = SubCatData[0].snm;
      this.apiService.successAlert("Please enter sub-category name.")
      return;
    }
    let flag = false;
    if(SubCatData[0].snm == name){
      flag = false
    }
    else{
      for (let i = 0; i < this.subCat.length; i++) {
        if(name == this.subCat[i].snm){
          flag = true
          break
        }
      }
    }
    
    this.tempData.subCategoryID = SubCatData[0].sid
    this.tempData.categoryID = this.typeID
    this.tempData.type = 'ITMCTGS'
    this.tempData.categoryName = name

    if(!flag){
      for(let i = 0; i < this.subCat.length; i++){
        if(this.subCat[i].sid == SubCatData[0].sid){
          this.subCat[i].snm = name;
          break
        }
      }
      this.save();
      this.modalReference.close();
    }
    else
    {
      this.tempData.categoryName = SubCatData[0].snm;
      this.apiService.successAlert("This sub-categories already exists.")
      return;
    }
  }

  deleteSubCat(i: number){
    var CatData = this.subCat.filter(function (element: any, index: any) {
      return (index == i);
    });
    this.tempData = {
      subCategoryID: CatData[0].sid,
      categoryID: this.typeID,
      categoryName: CatData[0].snm,
      type: 'ITMCTGSD' 
    }

    if(confirm("Do you wish to delete this sub-category?")){
      this.subCat.splice(i, 1);
      this.save();
    }
     
  }

  // save final data
  save(){
    for(let i = 0; i < this.categories.length; i++){
      if(this.categories[i].cid == this.mainCid){
        this.categories[i].sub = this.subCat;
        break
      }
    }
    var tempData = [{
      'ChangeType': this.tempData.type,
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '', //JSON.stringify(this.categories),
      'PrdJobStages': '',
      'ValnMethod':1,
      'PrdRejnReasons': '',
      'HSNSAC':'',
      'CategoryID': this.tempData.categoryID,
      'SubCategoryID': this.tempData.subCategoryID,
      'CategoryName': this.tempData.categoryName
  }]
  let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
  }];
  this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  //successVchrEntry - success voucher entry handler
  successEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
          if (ErpData.Table1) {
            let coockieData = [];
            coockieData.push(ErpData.Table1[0]);
            let ErpAgn = JSON.stringify(coockieData);
            localStorage.setItem("ERP_Agn", ErpAgn)
          }
          if (ErpData.Table2) {
            let cookieData2 = [];
            cookieData2.push(ErpData.Table2[0]);
            let ErpCfgData = JSON.stringify(cookieData2);
            localStorage.setItem("ERP_Cfg", ErpCfgData)
          }
    }
      this.subCat.sort((a:any,b:any) => a.snm.localeCompare(b.snm));
        //this.categories = [];
        //this.getCategory();    
        this.modalReference.close();
    }
  }

  //back() - back to settings
  back(){
    this.router.navigate(['Categories']);
  }


}
